import { z } from 'zod';
export const CampaignParamsSchema = z.object({
    id: z.string().uuid(),
    campaignName: z.string()
});
export const NotificationQueryParamsSchema = z.object({
    firstResult: z
        .union([z.number().int().nonnegative(), z.string()])
        .transform((value) => {
        if (typeof value === 'string') {
            const parsed = Number(value);
            return parsed;
        }
        return value;
    })
        .refine((value) => Number.isInteger(value) && value >= 0, {
        message: 'firstResult must be a non-negative integer'
    })
        .optional(),
    maxResults: z
        .union([z.number().int().positive(), z.string()])
        .transform((value) => {
        if (typeof value === 'string') {
            const parsed = Number(value);
            return parsed;
        }
        return value;
    })
        .refine((value) => Number.isInteger(value) && value > 0, {
        message: 'maxResults must be a positive integer'
    })
        .optional()
});
export const MarkMessageAsReadSchema = z.object({
    seenBySubscriber: z.boolean()
});
export const BaMessageIdSchema = z
    .object({
    id: z
        .union([z.number().int().positive(), z.string()])
        .transform((value) => {
        if (typeof value === 'string') {
            const parsed = Number(value);
            return parsed;
        }
        return value;
    })
        .refine((value) => Number.isInteger(value) && value > 0, {
        message: 'ID must be a positive integer'
    })
        .optional()
})
    .refine((data) => data.id > 0, {
    message: 'ID must be a positive integer'
});
//# sourceMappingURL=ba-notification.schemas.js.map